import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../../services/api/API";
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import html2pdf from "html2pdf.js";

const SurveyReport = () => {
  const [form, setForm] = useState({
    BusinessPartnerId: localStorage.getItem("BusinessPartnerId"),
    JobCardId: "",
    UploadVedio: null,
    fileAttr: "",
  });
  const [list, setList] = useState([]);
  const [selectedSurveyList, setSelectedSurveyList] = useState([]);
  const [surveyStatus, setSurveyStatus] = useState(false);
  const [ImageSurveyParameters, setImageSurveyParameters] = useState([]);
  const [fileArray, setFileArray] = useState(null);
  const location = useLocation();
  const productID = location.state.productId;
  const jobCardData = location.state.jobCardData;
  console.log("locationsurveyreport",location);
  
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const pdfRef = useRef();
  useEffect(() => {
    formBuild();
    getJobCardSurvey();
  }, []);

  const SelectionList = [
    {
      label: "0",
      value: 0,
    },
    {
      label: "1",
      value: 1,
    },
    {
      label: "2",
      value: 2,
    },
    {
      label: "3",
      value: 3,
    },
    {
      label: "4",
      value: 4,
    },
  ];

  const formBuild = () => {
    setForm((prevForm) => ({
      ...prevForm,
      BusinessPartnerId: localStorage.getItem("BusinessPartnerId"),
    }));
  };

  const handleFileChange = (e) => {
    setFileArray(e.target.files);
  };

  const getJobCardSurvey = async () => {
    const obj = {
      business_partner_id: 1,
      jobcard_id: jobCardData?.job_card_id,
      product_id: productID,
    };
    const data = await axiosInstance.post(
      "/jobcardsurvey/surveyimagelist",
      obj,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    bindJobCardSurvey(data);
  };

  const bindJobCardSurvey = (data) => {
    const surveyList = data?.data?.data?.surveylist?.data;
    setList(surveyList);
    const imageSurveyParameters = surveyList.filter(
      (value) => value.vehicle_image !== null
    );
    setImageSurveyParameters(imageSurveyParameters);
    const datalist = surveyList.filter((item) => item.mode === "EDIT");
    if (datalist.length > 0) {
      setSurveyStatus(true);
    } else {
      const selectedSurveyList = datalist.map((item) => ({
        BusinessPartnerId: item.business_partner_id,
        JobCardSurveyId: item.job_card_survey_id,
        JobCardId: jobCardData?.job_card_id,
        SurveyId: item.survey_id,
        IsSafe: item.is_safe,
        CreatedBy: localStorage.getItem("UserId"),
        UpdatedBy: localStorage.getItem("UserId"),
        IpAddress: "",
      }));
      setSelectedSurveyList(selectedSurveyList);
    }
  };

  const toggleSelection = (surveyId, currentIsSafe) => {
    setList((prevList) =>
      prevList.map((item) =>
        item.survey_id === surveyId
          ? {
              ...item,
              is_safe: currentIsSafe ? 0 : 1,
              survey_desc:
                item?.survey_desc == "SAFE"
                  ? "UNSAFE"
                  : item?.survey_desc == "UNSAFE"
                  ? "SAFE"
                  : item?.survey_desc == "NO"
                  ? "YES"
                  : "NO",
            } // Toggle the is_safe value
          : item
      )
    );
    if (currentIsSafe) {
      setSelectedSurveyList((prevList) =>
        prevList.filter((item) => item.SurveyId !== surveyId)
      );
    } else {
      // Selecting the item
      const selectedSurvey = list.find((item) => item.survey_id === surveyId);
      setSelectedSurveyList((prevList) => [
        ...prevList,
        {
          BusinessPartnerId: localStorage.getItem("BusinessPartnerId"),
          JobCardSurveyId: selectedSurvey.job_card_survey_id,
          JobCardId: jobCardData?.job_card_id,
          SurveyId: surveyId,
          IsSafe: 1,
          CreatedBy: localStorage.getItem("UserId"),
          UpdatedBy: localStorage.getItem("UserId"),
          IpAddress: "",
        },
      ]);
    }
    setImageSurveyParameters((prevParams) =>
      prevParams.map((param) =>
        param.survey_id === surveyId
          ? {
              ...param,
              is_safe: currentIsSafe ? 0 : 1,
              imageSrc: currentIsSafe
                ? `./../../../images/${param.vehicle_dent_image}.png`
                : `./../../../images/${param.vehicle_image}.png`,
            }
          : param
      )
    );
  };

  const handleToggleChange = (surveyId) => {
    const selectedItem = list.find((item) => item.survey_id === surveyId);
    toggleSelection(surveyId, selectedItem.is_safe === 1);
  };

  const handleSelectChenge = (selection, surveyId) => {
    setList((prevList) =>
      prevList.map((item) =>
        item.survey_id === surveyId
          ? { ...item, is_safe: selection?.value } // Toggle the is_safe value
          : item
      )
    );
    const selectedSurvey = list.find((item) => item.survey_id === surveyId);
    setSelectedSurveyList((prevList) => [
      ...prevList,
      {
        BusinessPartnerId: localStorage.getItem("BusinessPartnerId"),
        JobCardSurveyId: selectedSurvey.job_card_survey_id,
        JobCardId: jobCardData?.job_card_id,
        SurveyId: surveyId,
        IsSafe: selection?.value,
        CreatedBy: localStorage.getItem("UserId"),
        UpdatedBy: localStorage.getItem("UserId"),
        IpAddress: "",
      },
    ]);
  };

 const  handleSliderChenge =(selection, surveyId)=>{
  console.log(selection?.target?.value , surveyId)
  setList((prevList) =>
    prevList.map((item) =>
      item.survey_id === surveyId
        ? { ...item, is_safe: selection?.target?.value } // Toggle the is_safe value
        : item
    )
  );
  const selectedSurvey = list.find((item) => item.survey_id === surveyId);
  setSelectedSurveyList((prevList) => [
    ...prevList,
    {
      BusinessPartnerId: localStorage.getItem("BusinessPartnerId"),
      JobCardSurveyId: selectedSurvey.job_card_survey_id,
      JobCardId: jobCardData?.job_card_id,
      SurveyId: surveyId,
      IsSafe: selection?.value,
      CreatedBy: localStorage.getItem("UserId"),
      UpdatedBy: localStorage.getItem("UserId"),
      IpAddress: "",
    },
  ]);

 }
  const handleSubmit = async () => {
    if (surveyStatus) {
      const selectedData = list?.map(
        ({ is_safe, survey_id, job_card_survey_id }) => ({
          is_safe,
          survey_id,
          job_card_survey_id,
        })
      );
      try {
        const response = await axiosInstance.post(
          "/jobcardsurvey/update",
          {
            business_partner_id: 1,
            jobcard_id: jobCardData.job_card_id,
            survey_reqData: selectedData,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.data?.status == 200) {
          // navigate('/manage-services/job-card/job-card-details', { state: { data: JSON.parse(JSON.stringify(response?.data?.data?.responseData?.surveylist)) } });
        }
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
      console.log("selectedData", selectedData);
    } else {
      const selectedData = list?.map(
        ({ is_safe, survey_id, job_card_survey_id }) => ({
          is_safe,
          survey_id,
          job_card_survey_id,
        })
      );
      try {
        const response = await axiosInstance.post(
          "/jobcardsurvey/create",
          {
            business_partner_id: 1,
            jobcard_id: jobCardData.job_card_id,
            survey_reqData: selectedData,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.data?.status == 200) {
          
          navigate("manage-services/job-card");
          uploadFiles();
        }
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    }
  };

  const uploadFiles = async () => {
    if (fileArray?.length > 0) {
      const frmData = new FormData();
      frmData.append("doc_type", "I");
      frmData.append("jobcard_id", String(jobCardData.job_card_id));
      frmData.append("onboard_bp_id", "1");
      frmData.append("survayFile", fileArray[0]);
      const data = await axiosInstance.post(
        "/jobcardsurvey/surveyfileupload",
        frmData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }
  };

  const navigatetoJobCard = () => {
    navigate(-1)
  }

  const generatePdf = () => {
    const element = pdfRef.current;
    const options = {

      filename: "my-page.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf().from(element).set(options).save();
  };

  return (
    <>
    <span onClick={navigatetoJobCard} className="backbtntitle" style={{paddingLeft:"10px"}} >
          <img src={backicon} alt="back" style={{ marginRight: 5 }} /> 
          Survey Report
    </span>
    
     <div className="image-survey ">
        <div className="image-survey ">
          {ImageSurveyParameters.map((param, index) => (
            <div key={index} className="image-toggle-container ">
              <div className="image-wrapper">
                <img
                  src={param?.imageSrc}
                  alt={param.vehicleimagename}
                  // onClick={() =>
                  //   toggleSelection(param.survey_id, param.is_safe === 1)
                  // }
                  className={param.vehicle_image_class}
                />
              </div>
            </div>
          ))}
        </div>
      </div> 
      <div>
        <ToastContainer />
        <div ref={pdfRef}>
        <div className="container-fluid ">
          <div className="row g-2">
            <>
              <div className="col-md-12  d-flex flex-wrap overflow-y: auto max-height: 500px, ">
                {list.map((param, index) => (
                  <div className="col-md-4 py-2 ">
                    <div className="col-md-12 d-flex ">
                      <div className="col-md-6">
                        <span>{param?.survey_name || "-"}</span>
                      </div>
                      <div className="col-md-3  ">
                        <lable className="d-flex">
                          <span className="ms-3">
                            {param?.level_type === "Slider"
                              ? param?.is_safe
                              : param?.survey_desc}
                          </span>
                        </lable>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
            {/* ))} */}
          </div>
        </div>
        </div>
   
      </div>
      <div className="container-fluid ">
          <div className="row m-5 align-items: center;">
            <div className="col-9">
             
            </div> 
            <div className="col-3">
              <button onClick={generatePdf} className="submit-btn">
                {"Print "}
              </button>
            </div>
          </div>
        </div>
    </>
  );
};

export default SurveyReport;
